import Reacr from 'react';
import useQuery from '../../app/utilities/hooks';
import agent from '../../app/api/agent';
import { toast } from 'react-toastify';
import { Button, Header, Icon, Segment } from 'semantic-ui-react';

function RegisterSuccess() {
    const usQueryEmail = useQuery().get('email') as string;

    function handleResendEmailConfirmationLink() {
        agent.Account.resendEmailConfirmationLink(usQueryEmail).then(() => {
            toast.success('Verivication email resent - please check your email!');
        }).catch(error => console.log(error));
    }

    return (
        <Segment placeholder textAlign='center'>
            <Header icon color='green'><Icon name='check' />Successfully registerd!</Header>
            <p>Please ckeck your email (including junk email) for the verivication email</p>
            {usQueryEmail && 
                <>
                    <p>Didn't receive the email? Click the below button to resend</p>
                    <Button content='Resend email' primary size='huge' onClick={handleResendEmailConfirmationLink} />
                </>
            }
        </Segment>
    )
}

//export default RegisterSuccess();  //. x () >> JSX element type 'RegisterSuccess' does not have any construct or call signatures.
export default RegisterSuccess; 